import { render, staticRenderFns } from "./UDIOutlistBak.vue?vue&type=template&id=b88c9f64&scoped=true"
import script from "./UDIOutlistBak.vue?vue&type=script&lang=js"
export * from "./UDIOutlistBak.vue?vue&type=script&lang=js"
import style0 from "./UDIOutlistBak.vue?vue&type=style&index=0&id=b88c9f64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88c9f64",
  null
  
)

export default component.exports